module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//28.jpg?95565c04243ead4f20d5c73be0944f12";